import styles from "./Tasks.module.scss";

export default function Tasks() {
  return (
    <>
      <div className={styles.header}>Zadania</div>
      <div className={styles.tasksList}>Brak przypisanych zadań</div>
    </>
  );
}
